export default __webpack_public_path__ + "static/media/domains-white.d6875b5a.svg";